export * from './iconFontAwesomeAstronomyGlobe';
export * from './iconFontAwesomeAstronomyBinoculars';
export * from './iconFontAwesomeAstronomyMoon';
export * from './iconFontAwesomeAstronomyUserAstronaut';
export * from './iconFontAwesomeAstronomyShuttleSpace';
export * from './iconFontAwesomeAstronomySatelliteDish';
export * from './iconFontAwesomeAstronomySatellite';
export * from './iconFontAwesomeAstronomyMeteor';
